import { Handle, Position } from "reactflow"

interface HtmlNodeData {
  label: string
  html: string
  color: string
  layerName: string
  description?: string
  tooltip?: string
  type?: string
  width?: number
  height?: number
  nodeWidth: number
}

interface Props {
  data: HtmlNodeData
  selected: boolean
}

export function HtmlNode({ data, selected }: Props) {
  const hasTooltip = Boolean(data.tooltip)

  return (
    <div
      className={`group relative rounded-lg px-4 py-3.5 cursor-pointer select-none transition-all border bg-card text-foreground shadow-sm ${
        selected ? "shadow-lg" : "hover:shadow-md"
      }`}
      style={{
        width: data.width ?? data.nodeWidth ?? 220,
        minHeight: data.height,
        borderColor: selected ? data.color : undefined,
        borderLeftColor: data.color,
        borderLeftWidth: 4,
        boxShadow: selected ? `0 0 0 3px ${data.color}30` : undefined,
      }}
    >
      {hasTooltip && (
        <div
          className="pointer-events-none absolute left-1/2 top-full z-50 mt-2 hidden w-80 -translate-x-1/2 rounded-lg border border-border bg-popover px-3 py-2.5 text-left text-xs leading-relaxed text-popover-foreground shadow-xl group-hover:block"
          style={{ borderTopColor: data.color, borderTopWidth: 3 }}
        >
          <div className="mb-1.5 text-[10px] font-bold uppercase tracking-[0.1em]" style={{ color: data.color }}>
            {data.type ?? data.layerName}
          </div>
          <div className="font-semibold text-foreground">{data.label}</div>
          <div className="mt-1.5 text-muted-foreground">{data.tooltip}</div>
        </div>
      )}
      <Handle
        type="target"
        position={Position.Top}
        style={{ background: data.color, border: "2px solid white", width: 14, height: 14 }}
      />

      <div
        className="text-[11px] font-bold uppercase tracking-[0.08em] mb-2"
        style={{ color: data.color, opacity: 0.85 }}
      >
        {data.label}
      </div>

      <div dangerouslySetInnerHTML={{ __html: data.html }} className="text-sm leading-relaxed" />

      <Handle
        type="source"
        position={Position.Bottom}
        style={{ background: data.color, border: "2px solid white", width: 14, height: 14 }}
      />
    </div>
  )
}
